import { render, staticRenderFns } from "./slist.vue?vue&type=template&id=3c6f121b&scoped=true&"
import script from "./slist.vue?vue&type=script&lang=js&"
export * from "./slist.vue?vue&type=script&lang=js&"
import style0 from "./slist.vue?vue&type=style&index=0&id=3c6f121b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f121b",
  null
  
)

export default component.exports